import { z } from 'zod';

export const UserSchema = z.object({
  id: z.string(), // auth0 id
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
});

export type User = z.infer<typeof UserSchema>;
